import http from '@/utils/request';
// 查询购物车列表
export function listMallCartItem(query) {
  return http.request({
    url: `/mro/cartItem/list`,
    method: 'get',
    params: query,
  });
}

// 查询购物车数量
export function getCounts() {
  return http.request({
    url: `/mro/cartItem/getUserTotalCounts`,
    method: 'get',
  });
}
// 查询积分商城购物车数量
export function getPonitShopCounts(quary) {
  return http.request({
    url: `/mro/cartItem/getCounts`,
    method: 'get',
    params: quary,
  });
}

// 查询购物车详细
export function getMallCartItem(cartId) {
  return http.request({
    url: '/mro/cartItem/' + cartId,
    method: 'get',
  });
}

// 新增购物车
export function addMallCartItem(data) {
  return http.request({
    url: '/mro/cartItem/add',
    method: 'post',
    data: data,
  });
}

// 修改购物车
export function updateMallCartItem(query) {
  return http.request({
    url: '/mro/cartItem/quantity',
    method: 'put',
    params: query,
  });
}

// 删除购物车
export function delMallCartItem(cartIds) {
  return http.request({
    url: '/mro/cartItem/' + cartIds,
    method: 'delete',
  });
}

// 清空购物车
export function clearMallCartItem(query) {
  return http.request({
    url: `/mro/cartItem/clear`,
    method: 'get',
    params: query,
  });
}

//订单再次购买
export function addMallOrderCartItem(data) {
  return http.request({
    url: '/mro/cartItem/batchAdd',
    method: 'post',
    data: data,
  });
}

// 批量新增购物车 /mro/cartItem/batchAdd
export function batchAddMallCartItem(data) {
  return http.request({
    url: '/mro/cartItem/batchAdd',
    method: 'post',
    data: data,
  });
}
